import React from 'react';

import { Text } from '@reckon-web/text';

// ActivityCategory RecurrenceRemoved = 7
export const ActivityCategoryRecurrenceRemoved = () => (
  <Text size="small">Disabled recurrence</Text>
);
